import { render } from "./DropDown.vue?vue&type=template&id=923e42c4"
import script from "./DropDown.vue?vue&type=script&lang=js"
export * from "./DropDown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Chiche/Projects/mekiotech/authorizer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__